import React, { useState, useEffect } from 'react';
import {
  Grid,
  Paper,
  Typography,
  Box,
} from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import api from '../services/api';

function Dashboard() {
  const [stats, setStats] = useState({
    todaySubmissions: 0,
    openSubmissions: 0,
    totalSubmissions: 0,
  });
  const [chartData, setChartData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/api/admin/submissions');
        const submissions = response.data;
        
        // Calculate statistics
        const today = new Date().toISOString().split('T')[0];
        const todaySubmissions = submissions.filter(sub => 
          sub.timestamp.startsWith(today)
        ).length;
        
        const openSubmissions = submissions.filter(sub => 
          sub.status === 'open'
        ).length;

        setStats({
          todaySubmissions,
          openSubmissions,
          totalSubmissions: submissions.length,
        });

        // Prepare chart data (last 7 days)
        const last7Days = Array.from({ length: 7 }, (_, i) => {
          const date = new Date();
          date.setDate(date.getDate() - i);
          return date.toISOString().split('T')[0];
        }).reverse();

        const chartData = last7Days.map(date => ({
          date,
          submissions: submissions.filter(sub => 
            sub.timestamp.startsWith(date)
          ).length,
        }));

        setChartData(chartData);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setError('Failed to fetch dashboard data');
      }
    };

    fetchData();
  }, []);

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" color="text.secondary">
              Today's Submissions
            </Typography>
            <Typography variant="h3">
              {stats.todaySubmissions}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" color="text.secondary">
              Open Submissions
            </Typography>
            <Typography variant="h3">
              {stats.openSubmissions}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" color="text.secondary">
              Total Submissions
            </Typography>
            <Typography variant="h3">
              {stats.totalSubmissions}
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Paper sx={{ p: 2, height: 400 }}>
        <Typography variant="h6" gutterBottom>
          Submissions Last 7 Days
        </Typography>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="submissions" fill="#1976d2" name="Submissions" />
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Box>
  );
}

export default Dashboard; 